import * as autosize from "autosize";
import { filestackPicker } from "../framework/uploader";
import * as Popup from "../framework/components/popup";

$(document)
  .on("click", ".module .module-header .upload-image, .js-module-information__cover-image-button", onUploadImage)
  .on("click", ".module .module-header", onResizeTextarea);

const ID_LMS_POPUP = "js-lms-limitations-module-in-lib";

document.addEventListener("DOMContentLoaded", function () {
  openPopUp();
});

function openPopUp() {
  const popup = document.getElementById(ID_LMS_POPUP);
  if (popup) {
    Popup.open(popup);
  }
}

function onResizeTextarea() {
  setTimeout(function () {
    autosize.update($(".module .autoresize"));
  }, 0);
}

async function onUploadImage(e) {
  e.preventDefault();
  const $form = $(this).closest("form");
  const storagePath = $(this).data("upload-path");

  const { filesUploaded } = await filestackPicker({
    path: storagePath,
    accept: "image/*",
    transformations: { crop: true, rotate: true, circle: true },
    maxWidth: 2000,
    maxHeight: 2000,
  });

  if (filesUploaded?.length > 0) {
    $form.find(".image-url-input").val(filesUploaded[0].url);
    $form.find(".image-filename-input").val(filesUploaded[0].filename);
    $form.find(".image-size-input").val(filesUploaded[0].size);
    $form.find(".image-mime-input").val(filesUploaded[0].mimetype);
    $form.trigger("submit");
  }
}
